import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

export interface NoRowsOverlayParams {
	/**
	 * The src for the image to show. If undefined, an image will not be rendered.
	 */
	imageSrc?: string;
	/**
	 * The alt text for the image.
	 */
	imageAlt?: string;
	/**
	 * Text shown in a large font directly under the image.
	 */
	title?: string;
	/**
	 * Text shown in a slightly smaller font directly under the title.
	 */
	message?: string;
}

/**
 * Custom AG Grid no rows overlay component for showing no rows text along with an optional image.
 * The image is shown above the left expect on handsets in landscape mode, in which case the image
 * is shown to the left of the text.
 */
@Component({
	selector: 'sh-no-rows-overlay',
	styleUrls: ['./no-rows-overlay.component.scss'],
	imports: [CommonModule],
	template: `<div class="root-container">
		@if (params?.imageSrc) {
			<img class="image" [src]="params?.imageSrc" [alt]="params?.imageAlt" />
		}
		<div class="text-container">
			@if (params?.title) {
				<div class="prism-subtitle-1">{{ params?.title }}</div>
			}
			@if (params?.message) {
				<div class="prism-body-1 message">{{ params?.message }}</div>
			}
		</div>
	</div>`
})
export class NoRowsOverlayComponent {
	public params?: NoRowsOverlayParams;

	public agInit(params: NoRowsOverlayParams): void {
		this.params = params;
	}
}
